/* Rewards.

   Opens and closes the rewards pop-up, and puts the points in bold each time
   Smile.io writes its line. Elements are looked up by the data attributes
   beside the nextdev--pdp__rewards-* classes. */

(function () {
  'use strict';

  // Smile writes the sentence as plain text, number and all, and writes it
  // again on every variant change. The first whole number in it is the
  // points: it is wrapped in <strong>, once per write.
  function emphasise(text) {
    var line = text.querySelector('p') || text;
    if (line.querySelector('strong')) return;
    var walker = document.createTreeWalker(line, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var match = /\d[\d,.]*/.exec(node.nodeValue);
      if (!match) continue;
      var number = node.splitText(match.index);
      number.splitText(match[0].length);
      var strong = document.createElement('strong');
      number.parentNode.insertBefore(strong, number);
      strong.appendChild(number);
      return;
    }
  }

  function setup(root) {
    if (root.dataset.nextdevPdpRewardsInit) return;
    root.dataset.nextdevPdpRewardsInit = 'true';

    var dialog = root.querySelector('[data-nextdev-pdp-rewards-dialog]');
    var opener = root.querySelector('[data-nextdev-pdp-rewards-open]');
    var closer = root.querySelector('[data-nextdev-pdp-rewards-close]');
    var text = root.querySelector('[data-nextdev-pdp-rewards-text]');

    if (dialog && opener && typeof dialog.showModal === 'function') {
      opener.addEventListener('click', function () {
        if (!dialog.open) dialog.showModal();
      });
      if (closer) closer.addEventListener('click', function () { dialog.close(); });
      // a click on the ground around the sheet lands on the dialog itself
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
    }

    if (text) {
      emphasise(text);
      // Smile rewrites the line after load and on every variant change. The
      // wrap is a write of our own, so it is let through without looping:
      // emphasise does nothing while the number is already in bold.
      new MutationObserver(function () { emphasise(text); })
        .observe(text, { subtree: true, childList: true, characterData: true });
    }
  }

  function start() {
    document.querySelectorAll('[data-nextdev-pdp-rewards]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // the theme editor draws a section again after a change
  document.addEventListener('shopify:section:load', start);
})();
